import { render } from "./GasTestAssets.vue?vue&type=template&id=62d6eaa2"
import script from "./GasTestAssets.vue?vue&type=script&lang=js"
export * from "./GasTestAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__